import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homefour-features',
  templateUrl: './homefour-features.component.html',
  styleUrls: ['./homefour-features.component.scss']
})
export class HomefourFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
